export default __webpack_public_path__ + "static/media/whatsapp.523b4d6f.svg";